import * as React from 'react';
import * as styles from './table.module.scss';
import clsx from 'clsx';

interface Props {
  children: React.ReactNode;
  loading?: boolean;
  results?: Array<any>;
}

const Table = ({ children, loading, results }: Props) => {
  return <table className={clsx(loading && results.length > 0 && styles.loading, styles.table)}>{children}</table>;
};

export default Table;
